// extracted by mini-css-extract-plugin
export default {"wrapper":"Form_wrapper__XfrTu"};